import type { Conversation } from './types'

export const humaniseTool = (name: string): string =>
  name
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase())

export const humaniseSpeaker = (slug?: string): string | null => {
  const s = (slug ?? '').trim().toLowerCase()
  if (!s || s === 'supervisor') return null

  return s
    .split('_')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ')
}

export const hasPendingResolution = (
  conversation: Conversation | null | undefined
): boolean => {
  const messages = conversation?.messages ?? []
  const last = messages[messages.length - 1]

  return Boolean(
    last?.timeline?.some(
      (item) =>
        (item.kind === 'approval' || item.kind === 'question') &&
        item.status === 'pending'
    )
  )
}
